var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpaceshipSecondaryIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33334 8.59367C9.28212 6.23907 12.5 2.08325 12.5 2.08325C12.5 2.08325 15.7179 6.23907 16.6667 8.59367C18.2011 12.4016 15.625 18.7499 15.625 18.7499H9.375C9.375 18.7499 6.79895 12.4016 8.33334 8.59367Z",
    stroke: "#84878A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 18.75H20.8333L17.1875 12.5",
    stroke: "#84878A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37502 18.75H4.16669L7.81252 12.5",
    stroke: "#84878A",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4388 20.6101C10.7114 19.7281 11.1244 18.75 11.1244 18.75H13.8668C13.8668 18.75 14.2245 19.7506 14.5524 20.6101C14.8802 21.4697 12.5 23.4375 12.5 23.4375C12.5 23.4375 10.1663 21.4921 10.4388 20.6101Z",
    stroke: "#84878A",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 8.33325C8.33331 8.33325 9.89581 9.37492 12.5 9.37492C15.1041 9.37492 16.6666 8.33325 16.6666 8.33325",
    stroke: "#84878A",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceshipSecondaryIcon);
export default __webpack_public_path__ + "static/media/SpaceshipSecondaryIcon.89997144a3aa10cf060356773315bb7e.svg";
export { ForwardRef as ReactComponent };